import { PayloadAction } from '@reduxjs/toolkit';
import { LoginMessage } from 'Messages/LoginMessage';
import { createSlice } from '../../../utils copy/@reduxjs/toolkit';
import { AuthState } from '../types';

export const initialState: AuthState = {
  loading: false,
  loginFrom: { username: '', password: '', errors: [], success: '' },
  userData: {
    id: '',
    firstName: '',
    lastName: '',
    profilePic: '',
    email: '',
    username: '',
    usertype: ''
  },
  token: localStorage.getItem('token') || '',
  isLogin: true
};

export const useClinicSlice = createSlice({
  name: 'AuthState',
  initialState,
  reducers: {
    setUpdateToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      localStorage.setItem('token', action.payload);
    },

    setisLogin: (state, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload;
    },
    setProfileData: (
      state,
      action: PayloadAction<{
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        usertype: string;
      }>
    ) => {
      state.userData.id = action.payload.id;
      state.userData.firstName = action.payload.firstName;
      state.userData.lastName = action.payload.lastName;
      state.userData.email = action.payload.email;
      state.userData.usertype = action.payload.usertype;
    },
    getUserProfile: (state) => {},

    //Working
    doLogin: (state, action: PayloadAction<{ callback: () => void }>) => {
      state.loading = true;
      state.loginFrom.errors = [];
    },
    //Working
    doLogOut: (state) => {
      state.isLogin = true;
    },
    addLoginError: (state, action: PayloadAction<string>) => {
      state.loginFrom.errors.push(action.payload);
    },
    //Working
    loginSuccess: (state) => {
      state.loginFrom.success = LoginMessage.LOGIN_SUCCESS_MESSAGE;
    },
    updateFormValue: (state, action: PayloadAction<{ key: string; value: any }>) => {
      //@ts-ignore
      state.loginFrom[action.payload.key] = action.payload.value;
      state.loginFrom.errors = [];
    }
  }
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
